import {
  MATERIAL_SELECTION,
  MILLING_TYPE_SELECTION,
} from "../constants/constants";

const getMaterialLabel = (value) =>
  MATERIAL_SELECTION.find((item) => item.value === value)?.label || "";

const getMillingTypeLabel = (value) =>
  MILLING_TYPE_SELECTION.find((item) => item.value === value)?.label || "";

const buildHistorySummaryRows = (selectedToolData, selectedFeedRateData) => {
  if (!selectedToolData) return [];

  return [
    ["Submission", selectedToolData?.toolInputRefNo || ""],
    [
      "Created At",
      selectedToolData?.createdAt ?? selectedToolData?.created_at ?? "",
    ],
    [""],
    ["Input Parameters", ""],
    ["Tool Type", selectedToolData?.digibasicToolType || ""],
    ["Tool Diameter (mm)", selectedToolData?.diameter ?? ""],
    [
      "Tool Number of Flutes",
      selectedToolData?.fluteParameters?.helixAngle?.length ?? "",
    ],
    [
      "Tool Helix Angle (deg)",
      selectedToolData?.fluteParameters?.helixAngle?.join(", ") || "",
    ],
    [
      "Tool Pitch Angle (deg)",
      selectedToolData?.fluteParameters?.pitchAngle?.join(", ") || "",
    ],
    [
      "Depth of Cut (mm)",
      selectedToolData?.cuttingParameters?.depthOfCut ?? "",
    ],
    [
      "Width of Cut (mm)",
      selectedToolData?.cuttingParameters?.widthOfCut ?? "",
    ],
    [
      "Milling Type",
      getMillingTypeLabel(
        selectedToolData?.cuttingParameters?.millingTypeSelection
      ),
    ],
    [
      "Spindle Speed (RPM)",
      selectedToolData?.cuttingParameters?.spindleSpeed ?? "",
    ],
    [
      "Cutting Speed (m/min)",
      selectedToolData?.cuttingParameters?.cuttingSpeed ?? "",
    ],
    [
      "Feed Rate (mm/min)",
      selectedToolData?.cuttingParameters?.feedRate ?? "",
    ],
    [
      "Feed per Tooth (mm/tooth)",
      selectedToolData?.cuttingParameters?.feedPerTooth ?? "",
    ],
    [
      "Material Selection",
      getMaterialLabel(selectedToolData?.cuttingParameters?.materialSelection),
    ],
    ["Rake Angle", selectedToolData?.fluteParameters?.rakeAngle ?? ""],
    [""],
    ["Results", ""],
    [
      "Max Feed Force (N)",
      selectedFeedRateData?.original?.Max_Feed_Force ?? "",
    ],
    [
      "Max Cross Feed Force (N)",
      selectedFeedRateData?.original?.Max_CrossFeed_Force ?? "",
    ],
    [
      "Max Axial Force (N)",
      selectedFeedRateData?.original?.Max_Axial_Force ?? "",
    ],
    [
      "Max Side Force (N)",
      selectedFeedRateData?.original?.Max_Side_Force ?? "",
    ],
    ["Max Torque (Nm)", selectedFeedRateData?.original?.Max_Torque ?? ""],
    ["Max Power (W)", selectedFeedRateData?.original?.Max_Power ?? ""],
    [
      "Max Chip Thickness (mm)",
      selectedFeedRateData?.original?.Max_ChipThickness ?? "",
    ],
    ["Material Removal Rate (MRR)", selectedFeedRateData?.original?.MRR ?? ""],
    [""],
    ["Feed Rate Optimisation", ""],
    [
      "Optimisation Constraint",
      selectedToolData?.digibasicOptimisationConstraint ?? "-",
    ],
    [
      "Constraint Magnitude",
      selectedToolData?.selectedConstraintMagnitude ?? "-",
    ],
    [
      "Optimised Feed Rate (mm/min)",
      selectedFeedRateData?.optimum?.Feedrate_New ?? "",
    ],
  ];
};

const buildSeriesRows = (data) => {
  if (!data) return [];

  const filteredData = Object.keys(data)
    .filter(
      (key) =>
        !key.includes("Ave") && !key.includes("Max") && !key.includes("MRR")
    )
    .reduce((obj, key) => {
      obj[key] = data[key];
      return obj;
    }, {});

  const time = Object.keys(filteredData.Axial_Force || {});
  const axialForceData = Object.values(filteredData.Axial_Force || {});
  const crossFeedForceData = Object.values(filteredData.CrossFeed_Force || {});
  const feedForce = Object.values(filteredData.Feed_Force || {});
  const power = Object.values(filteredData.Power || {});
  const sideForce = Object.values(filteredData.Side_Force || {});
  const torque = Object.values(filteredData.Torque || {});

  const rows = [
    [
      "Angular Rotation",
      "Axial Force",
      "Cross Feed Force",
      "Feed Force",
      "Power",
      "Side Force",
      "Torque",
    ],
  ];

  for (let i = 0; i < time.length; i++) {
    rows.push([
      time[i],
      axialForceData[i],
      crossFeedForceData[i],
      feedForce[i],
      power[i],
      sideForce[i],
      torque[i],
    ]);
  }

  return rows;
};

export const buildHistorySummaryExportRows = (
  selectedToolData,
  selectedFeedRateData
) => {
  return buildHistorySummaryRows(selectedToolData, selectedFeedRateData);
};

export const buildHistorySeriesExportRows = (
  selectedFeedRateData,
  seriesType = "original"
) => {
  const seriesData =
    seriesType === "optimized"
      ? selectedFeedRateData?.optimum
      : selectedFeedRateData?.original;

  const seriesRows = buildSeriesRows(seriesData);

  return [
    [`${seriesType === "optimized" ? "Optimized" : "Original"} Series Data`],
    ...seriesRows,
  ];
};